import { IonButton, IonCol, IonGrid, IonIcon, IonItem, IonRow, isPlatform } from '@ionic/react';
import { chevronForward, chevronForwardOutline, informationCircleOutline, timeOutline } from 'ionicons/icons';

import moment from 'moment';
import QRCodeCanvas from 'qrcode.react';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getConfig } from '../../appConfig';
import AddToWallet from '../../components/addToWallet';
import {
  FieldError,
  NormalText,
  SmallText,
  Spacer,
  StrongText,
  Subtitle,
  Title,
} from '../../components/common';
import Layout from '../../components/layout';
import Modal from '../../components/modal';
import Loading from '../../components/spinner';
import api from '../../lib/api';
import Basket from '../../lib/basket';
import { withTranslation } from '../../lib/translate';
import {
  checkBackgroundColor,
  forwardTo,
  getLocale,
  getPointsValuePercentage,
  isDefined,
  isEmptyObject,
  isWebConfig,
  validateProfileData,
} from '../../lib/utils';
import {
  getFaq,
  getGiftCards,
  getLoyaltyInfo,
  getProfile,
  getRewards,
  getTransactionHistory,
  getVouchers,
  setModal,
} from '../../store/actions';
import KioskCodeGenerator from '../../components/kioskCode';

import './index.css';
import VoucherCodeInput from '../../components/voucherCodeInput';
import UnlockRewardItems from '../../components/unlockRewardItems';
import MilestoneRewards from '../../components/milestoneRewards';
import ValidateButton from '../../components/validateButton';
import { LoyaltyStatus } from '../../screens/loyaltyStatus';
import Register from '../register';
import LoyaltyRegister from '../loyaltyRegister';
import Rewards from '../../components/rewards';
import { VoucherModal } from '../voucher';

const VoucherListItem = ({ expiry_date, reward, id, className, action, __, reason }) => {
  return (
    <div onClick={action ? () => action(id) : null} className="voucher-list-wrapper" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <div>
        <StrongText className="block">{reward.name}</StrongText>
        <SmallText>
          {`${__('Expires')} ${moment(expiry_date, 'YYYY/MM/DD').format('LL')}`}
        </SmallText>
      </div>
      <IonIcon style={{ height: '18px', width: '18px' }} icon={chevronForward} />
    </div>
  );
};
export const getLabel = (item) => {
  let label = '';
  const defaultDescriptors = [
    {
      bl_id: '-1',
      label: 'Referral Bonus',
    },
    {
      bl_id: '-2',
      label: 'Sign up Bonus',
    },
    {
      bl_id: '-3',
      label: 'Refunded points',
    },
  ];
  const historyDescriptors = getConfig().history_descriptors || defaultDescriptors;

  const descriptors = historyDescriptors.filter((el) => el.bl_id === item.business_location_id);
  if (descriptors.length > 0) {
    label = descriptors[0].label;
  } else {
    let isPoints = item.is_points;
    let isStamps = item.is_stamps;
    let isVouchers = item.is_vouchers;
    let isVisit = item.is_visit;
    let subLabel = '';
    if (Math.abs(item.stamp_power) === 1) {
      subLabel = `${isPoints ? 'Point' : isVisit ? 'Visit' : isStamps ? 'Stamp' : isVouchers ? 'Voucher' : ''}`;
    } else if (item.stamp_power !== 1) {
      subLabel = `${isPoints ? 'Points' : isVisit ? 'Visits' : isStamps ? 'Stamps' : isVouchers ? 'Vouchers' : ''}`;
    }
    if (item.stamp_power < 0) {
      label = `${subLabel} redeemed`;
    } else if (item.stamp_power > 0) {
      label = `${subLabel} earned`;
    }
  }
  return label;
};
class Loyalty extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: null,
      loyaltyFaqModalOpened: false,
      voucherCode: '',
      selectedVoucher: null,
      formErrors: {
        voucherCode: '',
      },
      stampCards: [],
      stampCardModalOpen: false,
      stampCardData: null,
      keyboardIsVisible: false,
      groupedVouchers: [],
      logo_image: this.props.clientProfile.logo_image || '',
      logo_image_light:
        this.props.clientProfile.logo_image_light || this.props.clientProfile.logo_image || '',
      logoColor: 'dark',
      scrollToUnlockRewards: false,
      scrollToLoyaltyStatus: false,
    };
    this.loyaltyStatusRef = React.createRef()
    this.vouchersRef = React.createRef()
    this.unlockRewardsRef = React.createRef()
    this.formConfig = {
      voucherCode: { type: 'text', required: true },
    };
  }
  getVouchersSignature = (vouchers) =>
    (vouchers || [])
      .map((voucher) => `${voucher.id}:${voucher.expiry_date}`)
      .join('|');

  getVoucherGroups = (data) => {
    const groups = Object.values(
      data.reduce((acc, item) => {
        const key = item.reward.id;
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {})
    );
    groups.forEach(group => {
      group.sort((a, b) =>
        moment(a.expiry_date) - moment(b.expiry_date)
      );
    });
    groups.sort((a, b) => {
      return moment(a[0].expiry_date) - moment(b[0].expiry_date);
    });
    groups.sort((a, b) => {
      return isEmptyObject(a[0].reward.game_config) - isEmptyObject(b[0].reward.game_config)
    });
    return groups;
  };
  componentDidMount() {
    if (this.props?.auth?.loggedIn) {
      const styles = this.props.clientStyles?.colors?.['--okx-loyalty-card-background'];
      if (styles) {
        let logoColor = checkBackgroundColor(styles) || 'dark';
        this.setState({ logoColor });
      }
      this.props.dispatch(getRewards());
      // Stamp balances otherwise only refresh off the Firebase `timestamp` push.
      // If that listener is not live for the session, the card renders the
      // persisted profile indefinitely and appears frozen.
      this.props.dispatch(getProfile());
      this.props.dispatch(getTransactionHistory());
      this.props.dispatch(getLoyaltyInfo());
      this.props.dispatch(getGiftCards());

      const config = getConfig();

      const stampsPosition =
        config?.stamp_cards_json?.map((el) => Array(el.stamps_required).fill({})) || [];
      for (let i = 0; i < stampsPosition.length; i++) {
        for (let j = 0; j < stampsPosition[i].length; j++) {
          stampsPosition[i][j] = {
            top: this.getRandomNumber(-3, 3),
            left: this.getRandomNumber(-3, 3),
            rotate: this.getRandomNumber(-90, 90),
          };
        }
      }
      this.props.dispatch(getFaq());
      this.setState({ stampCards: config?.stamp_cards_json || [], stampsPosition });
      if (this.props?.location?.state?.openVoucherModal) {
        setTimeout(() => {
          this.viewVoucher(this.props.location.state.openVoucherModal);
        }, 500);
      }
      this.setState({ groupedVouchers: this.getVoucherGroups(this.props.vouchers.filter(voucher => voucher.voucher_type == 'voucher')) })
      if (this.props?.location?.state?.loyaltyStatus) {
        this.setState({ scrollToLoyaltyStatus: true });
        window.history.replaceState({}, '');
      }
      if (this.props?.location?.state?.scrollToVouchers) {
        setTimeout(() => {
          this.vouchersRef?.current?.scrollIntoView()
          window.history.replaceState({}, '')

        }, 500);
      }
      if (this.props?.location?.state?.scrollToUnlockRewards) {
        this.setState({ scrollToUnlockRewards: true });
        window.history.replaceState({}, '');
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props?.auth?.loggedIn) {
      if (this.props?.location?.state?.loyaltyStatus && prevProps.location !== this.props.location) {
        this.setState({ scrollToLoyaltyStatus: true });
        window.history.replaceState({}, '');
      }
      if (this.props?.location?.state?.scrollToVouchers && prevProps.location !== this.props.location) {
        setTimeout(() => {
          this.vouchersRef?.current?.scrollIntoView()
          window.history.replaceState({}, '')
        }, 500);
      }
      if (this.state.scrollToLoyaltyStatus && this.loyaltyStatusRef?.current) {
        this.setState({ scrollToLoyaltyStatus: false }, () => {
          setTimeout(() => {
            this.loyaltyStatusRef?.current?.scrollIntoView({ behavior: 'smooth' });
          }, 100);
        });
      }
      if (this.state.scrollToUnlockRewards && this.unlockRewardsRef?.current) {
        this.setState({ scrollToUnlockRewards: false }, () => {
          setTimeout(() => {
            this.unlockRewardsRef?.current?.scrollIntoView();
          }, 100);
        });
      }
      if (this.getVouchersSignature(prevProps.vouchers) !== this.getVouchersSignature(this.props.vouchers)) {
        this.setState({ groupedVouchers: this.getVoucherGroups(this.props.vouchers.filter(voucher => voucher.voucher_type == 'voucher')) })
      }
    }
  }

  viewVoucher = (id) => {
    const { vouchers } = this.props;
    this.setState({ selectedVoucher: vouchers.find((v) => v.id === id) })
  };

  redeemVoucher = () => {
    const { voucherCode } = this.state;
    if (voucherCode !== '') {
    }
  };
  getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }
  getNumberOfRowsAndColumns(stampNumber) {
    let data = {};
    if (stampNumber % 3 == 0) {
      data.columns = 'repeat(3,70px)';
      data.rows = '70px';
    }
    else if (stampNumber % 5 !== 0) {
      data.columns = 'repeat(4,50px)';
      data.rows = '50px';
    } else {
      data.columns = 'repeat(5,40px)';
      data.rows = '40px';
    }
    return data;
  }
  getStampImage = (url) => {
    if (url.startsWith('http') || url.startsWith('data:')) {
      return url

    } else {
      return `data:image/svg+xml;base64,${url}`
    }
  }
  onRefreshHandler = (e) => {
    setTimeout(() => {
      this.props.dispatch(getProfile());
      this.props.dispatch(getTransactionHistory());
      this.props.dispatch(getRewards());
      this.props.dispatch(getVouchers());
      this.props.dispatch(getProfile())
      e.target.complete();
    }, 2000);
  };
  getSelectedMembershipGroup = () => {
    const membershipGroups = [...(this.props.profile?.memberships?.filter(el => !isEmptyObject(el.styles)) ?? [])]?.sort((a, b) => a.sort_order - b.sort_order)
    return (membershipGroups && membershipGroups?.length > 0) ? membershipGroups[0] : []
  }
  getStampTitle(card) {
    const locale = getLocale(this.props.profile)
    if (card) {
      if (card.translations) {
        if (card.translations[`title_${locale}`]) {
          return card.translations[`title_${locale}`]
        }
      } else {
        return card.title
      }
    }


  }
  formatStampData = (card) => {
    const locale = getLocale(this.props.profile)
    if (card) {
      if (card.translations) {
        if (card.translations[`title_${locale}`] && card.translations[`title_${locale}`] !== '') {
          card.title = card.translations[`title_${locale}`]
        }
        if (card.translations[`pageInfo_${locale}`] && card.translations[`pageInfo_${locale}`] !== '') {
          card.stamp_content = card.translations[`pageInfo_${locale}`]
        }
        if (card.translations[`description_${locale}`] && card.translations[`description_${locale}`] !== '') {
          card.description = card.translations[`description_${locale}`]
        }
      }
    }

    return card
  }
  closeRewardModal = () => {
    this.props.dispatch(getVouchers());

  }

  renderLoyaltyStampCount = (numberOfStamps) => {
    const { __, profile } = this.props;
    if (getConfig().flags.hideLoyaltyStampCount) {
      return null;
    }
    const loyaltyStampBalanceDisplay = getConfig().general?.loyaltyStampBalanceDisplay;
    const milestoneBalance = profile?.milestone_balance || 0;
    const stampsCount = (
      <Subtitle className="bold ">{`${numberOfStamps} ${__(`${numberOfStamps == 1 ? 'stamp' : 'stamps'}`)}`}</Subtitle>
    );
    const milestonesCount = (
      <Subtitle className="bold ">{`${milestoneBalance} ${__(`${milestoneBalance == 1 ? 'point' : 'points'}`)}`}</Subtitle>
    );
    if (loyaltyStampBalanceDisplay === 'total_stamps') {
      return numberOfStamps > 0 ? stampsCount : null;
    }
    if (loyaltyStampBalanceDisplay === 'milestone_balance') {
      return milestoneBalance > 0 ? milestonesCount : null;
    }
    if (numberOfStamps > 0) {
      return stampsCount;
    }
    return milestoneBalance > 0 ? milestonesCount : null;
  }
  render() {
    const {
      __,
      profile,
      screenName,
      transactionHistory,
      faq,
      vouchers,
      qr_code,
      rewards,
      giftCards,
      clientStyles
    } = this.props;
    const { loyaltyFaqModalOpened, voucherCode, selectedVoucher, keyboardIsVisible, logo_image_light, logo_image } = this.state;

    const valid = validateProfileData(profile).isValid;
    let voucherRes = vouchers || [];

    const { hasAddToAppleWallet, hasAddToGoogleWallet } = getConfig().flags;
    const points_value_percentage = getPointsValuePercentage(this.props.profile)
    const numberOfStamps = profile?.stamp_cards_json?.reduce((sum, item) => sum + item.stamp_balance, 0) || 0;


    const currentTierData = getConfig().flags.hasLoyaltyTiers ? getConfig().tiers_json.find(tier => tier.id == profile?.current_tier?.current_tier_id) : false

    const selectedMembershipGroup = this.getSelectedMembershipGroup()

    let headerBanner = getConfig().general.loyaltyCardImage
    let logoColor = this.state.logoColor

    if (selectedMembershipGroup?.styles?.banner_image) {
      headerBanner = selectedMembershipGroup.styles.banner_image
    }
    if (selectedMembershipGroup?.styles?.logo_color) {
      logoColor = selectedMembershipGroup.styles.logo_color
    }
    const qrCodeSize = clientStyles?.qrCodeSize ? parseInt(clientStyles.qrCodeSize) : isWebConfig() ? 126 : 110
    const loyaltyTitle = getConfig().general?.sidebarConfig?.loyalty?.title ?? 'Loyalty and reward'


    const loyaltyOrder = getConfig().loyaltyOrder ?? {
      loyaltyStatus: 0,
      stampCards: 1,
      unlockRewards: 2,
      milestoneRewards: 3,
      vouchers: 4,
      giftCards: 5,
      eventCards: 6,
      topUpCards: 7

    }
    return (
      <Loading transparent>
        <Layout
          withRefresher={this.props.auth.loggedIn}
          onRefreshHandler={this.onRefreshHandler}
          color="transparent"
          noPadding={true}
          showHamburger
          headerWithTitle={getConfig().flags.removeLoyaltyTitle}
          title={__(loyaltyTitle)}
        >

          {this.props.auth?.loggedIn ? <>
            <div style={{ '--current-tier-background': currentTierData?.color_gradient ?? 'transparent' }} className={`scrollable-y ${keyboardIsVisible ? 'keyboard-is-visible' : ''}`}>
              {!getConfig().flags.removeLoyaltyTitle &&
                <Title className={'page-title-centered loyalty-header-title'} style={{ paddingLeft: 'var(--ion-padding-page)', paddingRight: 'var(--ion-padding-page)' }}>{__('Your loyalty card')}</Title>

              }
              {!getConfig().flags.loyaltyCardWithImage ? <div style={{ marginBottom: 'var(--spacer-5)', '--okx-loyalty-background': selectedMembershipGroup?.styles?.loyalty_card_background ?? 'var(--okx-loyalty-card-background)', '--okx-loyalty-text-color': selectedMembershipGroup?.styles?.text_color ?? 'var(--okx-loyalty-card-color)' }} className='loyalty-header-with-image-wrapper'>
                <ValidateButton />
                <IonGrid className='loyalty-header'>
                  <IonRow>
                    <IonCol>
                      <img src={logoColor === 'white' ? logo_image_light : logo_image} />
                    </IonCol>
                    <IonCol className='righted'>
                      {Basket.calculatePointsAppliedPrice(profile.available_balance) > 0 && !getConfig().flags.removeLoyaltyPointsWorth && (
                        <Title className='bold no-decorator'>
                          {Basket.formatPrice(Basket.calculatePointsAppliedPrice(profile.available_balance))}
                        </Title>
                      )}
                    </IonCol>
                  </IonRow>
                  <IonRow class='loyalty-card-image'>
                    <img src={headerBanner} />

                  </IonRow>
                  <IonRow style={profile?.memberships?.length > 0 ? { marginBottom: '0', display: 'grid', gridTemplateColumns: '1fr auto', gap: '10px' } : { display: 'grid', gridTemplateColumns: '1fr auto', gap: '10px' }}
                  >
                    <IonCol>
                      <Subtitle style={{ textAlign: 'left', wordBreak: 'break-word' }} className="bold">{screenName}</Subtitle>

                    </IonCol>
                    <IonCol style={{ alignSelf: 'start' }} className='righted'>
                      {this.renderLoyaltyStampCount(numberOfStamps)}
                    </IonCol>

                  </IonRow>
                  {(profile?.memberships?.length > 0) &&
                    <IonRow className="loyalty-header-groups">
                      {profile?.memberships && [...profile.memberships].sort((a, b) => a.sort_order - b.sort_order).map((tag, groupTagsIndex) => (
                        <SmallText className='membership-group' style={{ '--okx-membership-tag-background': tag?.styles?.tag_background_color ?? 'var(--okx-background-color)', '--okx-membership-tag-color': tag?.styles?.tag_color ?? 'var(--okx-label-color)' }} key={`membershiptag_${groupTagsIndex}`}>{tag.name}</SmallText>
                      ))}

                    </IonRow>
                  }

                  {!getConfig().flags.removeQRCodeOnLoyalty && (
                    <>
                      {isDefined(profile.qr_code) && profile.qr_code !== '' ? (
                        <>

                          <IonRow className='centered qr-code-wrapper'>
                            <div className="qr-code">
                              <div className={`${getConfig().flags.showConsumerID && profile.consumer_id ? 'qr-holder-with-consumer-id' : ''}  qr-holder`}>
                                <QRCodeCanvas value={profile.qr_code} size={qrCodeSize} />
                                {getConfig().flags.showConsumerID && profile.consumer_id && <StrongText>{profile.consumer_id}</StrongText>}
                              </div>
                            </div>
                          </IonRow>
                          {getConfig().general.loyaltyQRCodeText &&
                            <div className='centered' style={{ padding: '0 var(--ion-padding)' }}>
                              <Spacer size={2} />
                              <StrongText>{__(getConfig().general.loyaltyQRCodeText)}</StrongText>
                            </div>
                          }

                          <Spacer size={5} />
                        </>
                      ) : (
                        <></>
                      )}
                    </>
                  )}

                  {getConfig().flags.hasKioskCodeGenerator && (
                    <IonRow>
                      <KioskCodeGenerator />
                    </IonRow>
                  )}

                  {(points_value_percentage > 0 && profile.available_balance > 0) &&
                    <IonRow>

                      <IonCol>
                        <Subtitle style={{ display: 'flex', alignItems: 'center', textAlign: 'start' }}>{`${profile.available_balance} ${profile.available_balance == 1 ? __('point') : __('points')}`}
                          <IonIcon
                            style={{ marginLeft: '5px', cursor: 'pointer' }}
                            onClick={() => {
                              this.setState({ loyaltyFaqModalOpened: true });
                            }}
                            icon={informationCircleOutline}
                          />

                        </Subtitle>
                        {!getConfig().flags.removeLoyaltyPointsWorth &&
                          <SmallText>{`${__('worth')} ${Basket.formatPrice(Basket.calculatePointsAppliedPrice(profile.available_balance), false, getConfig().general.pointValue !== 1)}`}</SmallText>

                        }
                      </IonCol>
                      <IonCol className='righted'>
                        <Subtitle>{getConfig().general.loyaltyPointsInfoLine1 ? __(getConfig().general.loyaltyPointsInfoLine1) : `${__('Earn')} ${points_value_percentage} ${points_value_percentage == 1 ? __('point') : __('points')}`}</Subtitle>
                        <SmallText>{getConfig().general.loyaltyPointsInfoLine2 ? __(getConfig().general.loyaltyPointsInfoLine2) : `${__('every')} ${Basket.formatPrice(1).replace('.00', '')} ${__('spent')}`}</SmallText>
                      </IonCol>
                    </IonRow>

                  }

                </IonGrid>
                {isDefined(profile.qr_code) &&
                  profile.qr_code !== '' &&
                  (hasAddToAppleWallet || hasAddToGoogleWallet) ? (
                  <div className='centered'>
                    <AddToWallet />
                  </div>

                ) : null}
              </div> :

                <>

                  <div className="loyalty-header" style={{ backgroundImage: `url(${getConfig().general.loyaltyCardImage})` }} >
                    <div className="loyalty-header-name">
                      <Subtitle className="bold loyalty-name">{screenName}</Subtitle>
                      <div className="loyalty-header-groups">
                        {profile?.group_tags && profile.group_tags.map((tag, groupTagsIndex) => (
                          <SmallText key={`tag_${groupTagsIndex}`}>{tag}</SmallText>
                        ))}
                      </div>
                    </div>
                    <div className="loyalty-header-content">
                      <div>
                        {points_value_percentage == 0 && profile.available_balance == 0 ? (
                          <div></div>
                        ) : (
                          <div>
                            <Subtitle className="loyalty-points lowercase">
                              {profile.available_balance?.toLocaleString()} {__('pts')}{' '}
                              <IonIcon
                                onClick={() => {
                                  this.setState({ loyaltyFaqModalOpened: true });
                                }}
                                icon={informationCircleOutline}
                                className='text-color'
                              />
                            </Subtitle>
                            {Basket.calculatePointsAppliedPrice(profile.available_balance) > 0 && !getConfig().flags.removeLoyaltyPointsWorth && (
                              <SmallText className="loyalty-points-value">
                                {`${__('worth')} ${Basket.formatPrice(Basket.calculatePointsAppliedPrice(profile.available_balance), false, getConfig().general.pointValue !== 1)}`}
                              </SmallText>
                            )}

                          </div>
                        )}

                        <div>
                          <SmallText className="block is-uppercase">{__('Member since')}</SmallText>
                          <SmallText className="uppercase ">{moment(profile.created_at).format('MM/YY')}</SmallText>
                        </div>
                      </div>

                      <div style={{ flexDirection: 'column' }}>
                        {!getConfig().flags.removeQRCodeOnLoyalty && (
                          <>
                            {isDefined(profile.qr_code) && profile.qr_code !== '' ? (
                              <div className='qr-code-wrapper' style={{ alignSelf: 'center' }}>

                                <div className="qr-code">
                                  <div className={`${getConfig().flags.showConsumerID && profile.consumer_id ? 'qr-holder-with-consumer-id' : ''}  qr-holder`}>
                                    <QRCodeCanvas value={profile.qr_code} size={qrCodeSize} />
                                    {getConfig().flags.showConsumerID && profile.consumer_id && <StrongText style={{ width: '100%' }} className='block'>{profile.consumer_id}</StrongText>}
                                  </div>
                                </div>
                              </div>

                            ) : (
                              <></>
                            )}
                          </>
                        )}
                        {isDefined(profile.qr_code) &&
                          profile.qr_code !== '' &&
                          (hasAddToAppleWallet || hasAddToGoogleWallet) ? (
                          <>
                            <AddToWallet />
                            <Spacer size={2} />
                          </>
                        ) : null}
                        {!isWebConfig() && getConfig().flags.hasKioskCodeGenerator && (
                          <>
                            {' '}
                            <KioskCodeGenerator />
                            <Spacer size={2} />
                          </>
                        )}
                      </div>
                    </div>
                    {isWebConfig() && getConfig().flags.hasKioskCodeGenerator && (
                      <>
                        <Spacer size={2} /> <KioskCodeGenerator />
                      </>
                    )}
                  </div>
                  <div
                    onClick={() => {
                      !valid && this.props.dispatch(setModal('isVerfiedModalOpen', true));
                    }}
                    className={`loyalty-validation-wrapper ${!valid && 'invalid'}`}
                  >
                    <NormalText>{valid ? __('Account verified') : __('Account not verified')}</NormalText>
                  </div>
                </>
              }
              <div className='loyalty-page-content'>
                {getConfig().flags.hasLoyaltyTiers && currentTierData &&
                  <div style={{ order: loyaltyOrder['loyaltyStatus'] }} ref={this.loyaltyStatusRef}>
                    <LoyaltyStatus />
                  </div>}
                {this.state.stampCards.length > 0 && (
                  <div style={{ order: loyaltyOrder['stampCards'] }} className="stamps-content">
                    <Title className='page-title-centered' >
                      {__('Your stamp cards')}
                    </Title>

                    {this.state.stampCards
                      .filter((el) => el.is_global && el.is_published)
                      .map((card, stampIndex) => {
                        const stampCard = this.formatStampData(card)
                        return (
                          <React.Fragment key={`stamp-card_${stampIndex}`}>
                            <div
                              style={{
                                backgroundColor: stampCard?.additional_config?.background_color ?? stampCard?.background_color,
                                color: stampCard?.additional_config?.text_color ?? stampCard?.text_color,
                              }}
                              className="stamps-wrapper box-wrapper">
                              {stampCard?.additional_config?.banner_image &&
                                <img src={`${stampCard?.additional_config?.banner_image}`} className='stamps-box-image' />

                              }
                              <div className="stamps-box-header">
                                <div>
                                  {!stampCard?.additional_config?.removeTitle &&
                                    <Subtitle
                                      style={{ "--custom-text-color": stampCard?.additional_config?.text_color ?? stampCard?.text_color }}
                                      className='bold text-to-update'>{__(stampCard?.title)}</Subtitle>
                                  }
                                  {!stampCard?.additional_config?.removeDescription &&
                                    <NormalText
                                      style={{ "--custom-text-color": stampCard?.additional_config?.text_color ?? stampCard?.text_color }}
                                      className=''>{__(stampCard?.description)}</NormalText>
                                  }
                                </div>
                                {!stampCard?.additional_config?.removeInfo &&
                                  <IonIcon
                                    className='text-color'
                                    onClick={() => {
                                      this.setState({
                                        stampCardModalOpen: true,
                                        stampCardData: this.formatStampData(stampCard),
                                      });
                                    }}
                                    style={{ "--custom-text-color": stampCard?.additional_config?.text_color ?? stampCard?.text_color }}
                                    icon={informationCircleOutline}
                                  />
                                }

                              </div>

                              <div
                                className="stamps-box"
                                style={{
                                  gridTemplateColumns: this.getNumberOfRowsAndColumns(
                                    stampCard?.stamps_required,
                                  ).columns,
                                  gridAutoRows: this.getNumberOfRowsAndColumns(stampCard?.stamps_required)
                                    .rows,
                                }}
                              >
                                {Array(stampCard?.stamps_required)
                                  .fill(null)
                                  .map((item, index) => {
                                    return (
                                      <div
                                        key={index}
                                        className={
                                          index <
                                            (profile?.stamp_cards_json || []).filter(
                                              (item) => item.id === stampCard.id,
                                            )[0]?.stamp_balance
                                            ? 'stamp-photo redeemable-stamp-photo'
                                            : 'stamp-photo locked-stamp-photo'
                                        }

                                        style={{
                                          backgroundColor: stampCard?.additional_config?.placeholder_color
                                        }}
                                      >
                                        {(stampCard?.additional_config?.stamp_placeholder_svg || stampCard?.stamp_bg_svg) &&
                                          <img
                                            alt="stamp"
                                            className='placeholder-stamp'

                                            src={this.getStampImage(`${stampCard?.additional_config?.stamp_placeholder_svg ?? stampCard?.stamp_bg_svg}`)}
                                          />
                                        }
                                        {index <
                                          (profile?.stamp_cards_json || []).filter(
                                            (item) => item.id === stampCard.id,
                                          )[0]?.stamp_balance &&
                                          <img
                                            alt="stamp "
                                            style={{
                                              ...(stampCard?.additional_config?.removeStampRotation ? {} : {
                                                transform: `rotate(${this.state.stampsPosition[stampIndex][index].rotate}deg)`,
                                                top: this.state.stampsPosition[stampIndex][index].top,
                                                left: this.state.stampsPosition[stampIndex][index].left,
                                              })
                                            }}
                                            src={this.getStampImage(`${stampCard?.additional_config?.stamp_svg ?? stampCard?.stamp_svg}`)}
                                          />
                                        }

                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                  </div>
                )}

                {getConfig().flags.hasUnlockRewards && rewards.length > 0 && (
                  <>
                    <div ref={this.unlockRewardsRef} style={{ order: loyaltyOrder['unlockRewards'] }} className="loyalty-content">
                      {getConfig().flags.hasUpdatedRewardsUI ?
                        <Rewards vouchers={voucherRes.filter((voucher) => voucher.voucher_type == 'unlock_reward')} unlockRewards={true} available_points={profile.available_balance} rewards={rewards} qr_code={qr_code} __={__} />
                        :
                        <>
                          <UnlockRewardItems available_balance={profile.available_balance} rewards={rewards} qr_code={qr_code} __={__} />
                          {voucherRes.filter((voucher) => voucher.voucher_type == 'unlock_reward').length > 0 &&
                            <div className="box-wrapper">
                              {voucherRes &&
                                voucherRes
                                  .filter((voucher) => voucher.voucher_type == 'unlock_reward')
                                  .map((voucher, index) => {
                                    return <VoucherListItem key={'vc-' + index} {...voucher} __={__} action={this.viewVoucher} />;
                                  })}
                            </div>
                          }
                        </>


                      }
                    </div>


                  </>
                )}
                {getConfig().flags.hasMilestoneRewards && rewards.length > 0 && (
                  <>
                    <div style={{ order: loyaltyOrder['milestoneRewards'] }} className="loyalty-content">
                      {getConfig().flags.hasUpdatedRewardsUI ?

                        <Rewards vouchers={voucherRes.filter((voucher) => voucher.voucher_type == 'milestone')} milestoneRewards={true} available_points={profile.milestone_balance} rewards={rewards} qr_code={qr_code} __={__} />
                        :
                        <>
                          <MilestoneRewards lifetime_balance={profile.milestone_balance} rewards={rewards} qr_code={qr_code} __={__} />
                          {voucherRes.filter((voucher) => voucher.voucher_type == 'milestone').length > 0 &&
                            <div className="box-wrapper milestone-rewards">
                              {voucherRes &&
                                voucherRes
                                  .filter((voucher) => voucher.voucher_type == 'milestone')
                                  .map((voucher, index) => {
                                    return <VoucherListItem key={'vc-' + index} {...voucher} __={__} action={this.viewVoucher} />;
                                  })}
                            </div>
                          }
                        </>}
                    </div>

                  </>
                )}
                {getConfig().flags.hasVouchers &&
                  <div style={{ order: loyaltyOrder['vouchers'] }}>
                    {voucherRes.length > 0 &&
                      <div className="loyalty-vouchers-wrapper" ref={this.vouchersRef}>
                        <FieldError className="field-error" value={__(this.state.formErrors.voucherCode)} />
                        <>
                          <Title className='page-title-centered'>{__('Your vouchers')}</Title>
                          {this.state.groupedVouchers.map((group, groupId) => {
                            const voucher = group[0];
                            const hasDifferentExpiries = new Set(group.map((v) => moment(v.expiry_date, 'YYYY/MM/DD').format('YYYY-MM-DD'))).size > 1;
                            return (
                              <div key={`group_${groupId}`} className='voucher-wrapper' onClick={() => {
                                if (isEmptyObject(voucher?.reward?.game_config)) {
                                  this.viewVoucher(voucher.id)
                                } else {
                                  forwardTo('/spin-and-win', {
                                    voucher: voucher
                                  })
                                }
                              }}>
                                <div className='voucher-overlay pointer'>
                                  <img className='voucher-image' src={voucher.reward.image} />

                                </div>
                                <div className='voucher-description'>
                                  <StrongText className='text-to-update'>{voucher.reward.name}</StrongText>
                                  <div>
                                    <SmallText className='bold voucher-counter'>{voucher.reward.is_multi_use ? __('Multi-use') : group.length === 1 ? __('Single-use') : `x${group.length} ${__('available')}`}</SmallText>
                                    <SmallText className='voucher-expiry'>
                                      {voucher.never_expires
                                        ? __('No expiry')
                                        : <>
                                          <IonIcon icon={timeOutline} />
                                          {`${__(group.length > 1 && hasDifferentExpiries ? 'Soonest expiry' : 'Expires')} ${moment(voucher.expiry_date, 'YYYY/MM/DD').format('LL')}`}
                                        </>}
                                    </SmallText>

                                  </div>
                                </div>
                              </div>
                            )
                          })}
                        </>
                      </div>

                    }
                    {!getConfig().flags.removeVoucherCodeOnLoyalty &&
                      <>
                        <Spacer size={5} />
                        <VoucherCodeInput showButton voucherAddedModalOpen={this.props.voucherAddedModalOpen} />
                      </>
                    }

                  </div>
                }
                {giftCards.filter(el => !el.is_event_card && !el.is_topup_card).length > 0 && !getConfig().flags.removeGiftCards && !getConfig().flags.hasGiftCards &&
                  <div style={{ order: loyaltyOrder['giftCards'] }} className='loyalty-content'>
                    <Title className='page-title-centered'>{__('Gift cards')}</Title>
                    <div className='box-wrapper'>
                      {giftCards.filter(el => !el.is_event_card && !el.is_topup_card).map((card, giftCardIndex) => {
                        let isExpired = false
                        let expiresToday = false
                        const dateToCheck = card.expiry_date
                        const today = moment().startOf('day');
                        const checkDate = moment(dateToCheck, 'DD/MM/YYYY').startOf('day');

                        if (checkDate.isBefore(today)) {
                          isExpired = true
                        } else if (checkDate.isSame(today)) {
                          expiresToday = true
                        }
                        return (
                          <IonItem key={`gift-card_${giftCardIndex}`} className='pointer' lines='none' onClick={() => forwardTo('/gift-card', { card, isExpired, expiresToday })}>
                            <div>
                              <StrongText className='block'>{card.value_remaining_str}</StrongText>
                              <Spacer size={0} />
                              <SmallText className={`${isExpired ? 'danger-color' : ""}`}>{expiresToday ? __('Expires today') : `${isExpired ? __('Expired:') : __('Expires:')} ${card.expiry_date}`}</SmallText>
                            </div>
                            <IonIcon style={{ height: '18px', width: '18px' }} slot='end' icon={chevronForwardOutline} />
                          </IonItem>
                        )
                      }
                      )}
                    </div>
                  </div>
                }
                {giftCards.filter(el => el.is_event_card).length > 0 && !getConfig().flags.removeEventCards &&
                  <div style={{ order: loyaltyOrder['eventCards'] }} className='loyalty-content'>
                    <Title className='page-title-centered'>{__('Event cards')}</Title>
                    <div className='box-wrapper'>
                      {giftCards.filter(el => el.is_event_card).map((card, eventCardIndex) => {
                        let isExpired = false
                        let expiresToday = false
                        const dateToCheck = card.expiry_date
                        const today = moment().startOf('day');
                        const checkDate = moment(dateToCheck, 'DD/MM/YYYY').startOf('day');
                        if (checkDate.isBefore(today)) {
                          isExpired = true
                        } else if (checkDate.isSame(today)) {
                          expiresToday = true
                        }
                        return (
                          <IonItem key={`event-card_${eventCardIndex}`} className='pointer' lines='none' onClick={() => forwardTo('/gift-card', { card, isExpired, expiresToday })}>
                            <div>
                              <StrongText className='block'>{card.value_remaining_str}</StrongText>
                              <Spacer size={0} />
                              <SmallText className={`${isExpired ? 'danger-color' : ""}`}>{expiresToday ? __('Expires today') : `${isExpired ? __('Expired:') : __('Expires:')} ${card.expiry_date}`}</SmallText>
                            </div>
                            <IonIcon style={{ height: '18px', width: '18px' }} slot='end' icon={chevronForwardOutline} />
                          </IonItem>
                        )
                      }
                      )}
                    </div>
                  </div>
                }
                {giftCards.filter(el => el.is_topup_card).length > 0 && !getConfig().flags.removeTopUpCards &&
                  <div style={{ order: loyaltyOrder['topUpCards'] }} className='loyalty-content'>
                    <Title className='page-title-centered'>{__('Top Up cards')}</Title>
                    <div className='box-wrapper'>
                      {giftCards.filter(el => el.is_topup_card).map((card, topUpCardIndex) => {
                        let isExpired = false
                        let expiresToday = false
                        const dateToCheck = card.expiry_date
                        const today = moment().startOf('day');
                        const checkDate = moment(dateToCheck, 'DD/MM/YYYY').startOf('day');

                        if (checkDate.isBefore(today)) {
                          isExpired = true
                        } else if (checkDate.isSame(today)) {
                          expiresToday = true
                        }
                        return (
                          <IonItem key={`top-up-card_${topUpCardIndex}`} className='pointer' lines='none' onClick={() => forwardTo('/gift-card', { card, isExpired, expiresToday })}>
                            <div>
                              <StrongText className='block'>{card.value_remaining_str}</StrongText>
                              <Spacer size={0} />
                              <SmallText className={`${isExpired ? 'danger-color' : ""}`}>{expiresToday ? __('Expires today') : `${isExpired ? __('Expired:') : __('Expires:')} ${card.expiry_date}`}</SmallText>
                            </div>
                            <IonIcon style={{ height: '18px', width: '18px' }} slot='end' icon={chevronForwardOutline} />
                          </IonItem>
                        )
                      }
                      )}
                    </div>
                  </div>
                }
              </div>
              <div className="loyalty-history">
                {transactionHistory.length > 0 && (
                  <>
                    <Spacer size={5} />
                    <Title className='page-title-centered'>
                      {__('Your latest activity')}
                    </Title>
                    <div className="transactions-wrapper box-wrapper">
                      {transactionHistory.slice(0, 3).map((el, index) => {
                        let locationName = el.location_name && el.location_name !== '' ? el.location_name : null;
                        return (
                          <div key={index} className="small-padding ">
                            <IonRow key={index}>
                              <IonCol
                                size="8"
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  flexDirection: 'column',
                                }}
                              >
                                {locationName &&
                                  <div className='ellipsis small-text text-to-update'>{locationName}</div>
                                }
                                {el.is_vouchers && <div className='ellipsis small-text text-to-update'>{__(el.reason_balance)}</div>}

                                <StrongText className=" break-spaces  block text-to-update ">{__(getLabel(el))}</StrongText>
                                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                  <SmallText style={{ marginRight: '4px' }}>{Basket.getDate(el.transaction_date.replace('Z', '')).format(`DD MMM YYYY [${__('at')}]`)}</SmallText>
                                  <SmallText>{Basket.getDate(el.transaction_date.replace('Z', '')).format(' h:mm a')}</SmallText>
                                </div>
                              </IonCol>
                              <IonCol
                                ize="4"
                                style={{
                                  display: 'grid',
                                  justifyContent: 'flex-end',
                                  alignItems: 'center',
                                }}
                              >
                                {!el.is_vouchers &&
                                  <div className="transaction-points-wrapper">


                                    <Subtitle className={el.is_vouchers ? 'bold' : el.stamp_power < 0 ? 'bold danger-color' : 'bold success-color'}>
                                      <>
                                        {el.stamp_power < 0 ? '-' : '+'}
                                        {Math.abs(el.stamp_power)}
                                      </>
                                    </Subtitle>
                                    {el.is_visit ? (
                                      <SmallText>{Math.abs(el.stamp_power) == 1 ? __('visit') : __('visits')}</SmallText>
                                    ) : el.is_stamps ? (
                                      <SmallText>{Math.abs(el.stamp_power) == 1 ? __('stamp') : __('stamps')}</SmallText>
                                    ) : el.is_points ? (
                                      <SmallText>{Math.abs(el.stamp_power) == 1 ? __('point') : __('points')}</SmallText>
                                    ) : null}
                                  </div>
                                }
                              </IonCol>
                            </IonRow>
                          </div>
                        );
                      })}

                      {transactionHistory.length > 3 && (
                        <div className="small-padding ">

                          <IonButton

                            className="link "
                            color="secondary"
                            expand="block"
                            onClick={() => forwardTo('/history')}
                          >
                            {__('Show all activity')}
                          </IonButton>
                        </div>

                      )}
                    </div>
                  </>
                )}
                <Spacer size={3} />

              </div>
            </div>
            <Modal
              className="loyalty-faq-modal"
              isOpen={this.state.stampCardModalOpen}
              onDidDismiss={() => {
                this.setState({ stampCardModalOpen: false });
              }}
            >
              <div className="lefted">
                <Title className='modal-title'>{this.state.stampCardData?.title}</Title>
                <Spacer size={2} />
                <NormalText
                  dangerouslySetInnerHTML={{
                    __html: this.state.stampCardData?.stamp_content,
                  }}
                ></NormalText>
              </div>
            </Modal>
            <Modal
              className="loyalty-faq-modal"
              isOpen={loyaltyFaqModalOpened}
              onDidDismiss={() => {
                this.setState({ loyaltyFaqModalOpened: false });
              }}
            >
              <div className="lefted">
                <Subtitle className='modal-title'>{__('Loyalty Info')}</Subtitle>
                <div dangerouslySetInnerHTML={{ __html: this.props.loyaltyInfo }}></div>
              </div>{' '}
            </Modal>


            <VoucherModal
              voucher={selectedVoucher}
              onDismiss={() => {
                this.setState({ selectedVoucher: null });
                this.props.history.replace({ state: {} });
              }}
            />
          </> :
            < >
              <LoyaltyRegister showOnlyFields={true} />
            </>
          }
        </Layout>
      </Loading>
    );
  }
}

const stateToProps = (state) => {
  const { profile, auth, giftCards } = state.profile;
  const { rewards } = state.restaurants;
  const { history } = state.orders;
  const { clientProfile, clientStyles, voucherAddedModalOpen } = state.common;
  let screenName = '';
  if (
    (isDefined(profile) && !isEmptyObject(profile) && profile.first_name) ||
    profile.last_name ||
    (profile.first_name && profile.last_name)
  ) {
    screenName = `${profile.first_name} ${profile.last_name}`;
  }
  return {
    screenName,
    profile,
    auth,
    rewards: rewards || [],
    transactionHistory: history || [],
    faq: state.common.faq || null,
    vouchers: state.profile.vouchers || [],
    qr_code: state.profile.profile.qr_code,
    clientProfile,
    loyaltyInfo: state.common.loyaltyInfo,
    giftCards: giftCards || [],
    voucherAddedModalOpen,
    clientStyles,



  };
};

export default connect(stateToProps)(withRouter(withTranslation(Loyalty)));
